import { Component, OnInit,ViewEncapsulation, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-popup-question',
  templateUrl: './popup-question.component.html',
  styleUrls: ['./popup-question.component.sass']
})
export class PopupQuestionComponent implements OnInit {
  public name;
  public questionsData;
  public challengeQuestionsData;
  public questionID1:Object;
  public questionID2:Object;
  public pregunta1:string;
  public pregunta2:string;
  public popPreguntasSeguridad:boolean;
  constructor(private loadingScreenService :LoadingScreenService,private services: Service,private global:GlobalService,public matDialogRef:MatDialogRef<PopupQuestionComponent>,@Inject(MAT_DIALOG_DATA) public data: any, private router:Router) { }

  ngOnInit() {
    if(this.global.sessionReview()==true){
      this.getquestions(sessionStorage.getItem("token"));
    }
  }
  public close(){;
    this.matDialogRef.close('cancel');
  }
  getquestions(token){
    this.services.getquestions(token).subscribe(data =>{
      if(data.hasError ==false){ 
          sessionStorage.setItem("getquestions",btoa(JSON.stringify(data)));
          this.questionsData=JSON.parse(atob(sessionStorage.getItem("getquestions"))).QuestionsItemsList;
      }
      else{
        this.loadingScreenService.stopLoading();
        this.global.notif(data.ErrorDesc);
      }
    });
  }
  aceptarPreguntas() {
    this.global.validateSession();
    if (this.questionID1!==''&&this.questionID1!==undefined) {
          if(this.pregunta1 !== ''&&this.pregunta1 !== undefined){
          this.services.setchallengequestions(sessionStorage.getItem("token"),this.questionID1,this.pregunta1).subscribe(data =>{
              if (data.hasError ==false) {
                  if(this.questionID2!=='' &&this.questionID2!==undefined){
                      if (this.pregunta2 !== '' &&this.pregunta2 !== undefined) {
                          this.loadingScreenService.startLoading();
                          this.popPreguntasSeguridad = false;
                          sessionStorage.setItem("popPreguntasSeguridad",btoa(JSON.stringify(this.popPreguntasSeguridad)));
                          this.services.setchallengequestions(sessionStorage.getItem("token"),this.questionID2,this.pregunta2).subscribe(data =>{
                            if(data.hasError ==false){
                              this.loadingScreenService.stopLoading();
                              this.global.notif("Se han actualizado las preguntas de seguridad.");
                              this.close();
                            }
                            else{
                              this.loadingScreenService.stopLoading();
                              this.global.notif(data.errorDesc);
                            }
                          });
                      }
                      else {
                          this.global.notif("Debe colocar una respuesta para la segunda pregunta.");
                      }
                  }
                  else{
                      this.global.notif("Debe seleccionar la segunda pregunta.");
                  }
              } 
              else {
                  this.global.notif(data.errorDesc);    
              }
          });
        }
        else{
          this.global.notif("Debe colocar una respuesta para la primera pregunta.");
        }
    }
    else {
        this.global.notif("Debe seleccionar la primera pregunta secreta.");
    }
  }
}